import React, { useState, useEffect, FC, useCallback, useRef } from "react";
import Content from "../../layout/content/Content";
import { Card, Col, Button, Badge, Spinner } from "reactstrap";
import {
  Table,
  Select,
  Input,
  Flex,
  Spin,
  Empty,
  Tooltip,
  Form,
  InputNumber,
  Drawer,
  Collapse,
  Popover,
  DatePicker,
  Modal as AntdModal,
  Space,
  Radio,
  message,
} from "antd";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  TooltipComponent,
} from "../../components/Component";
import FormatDate from "../masters/DateFormater";
import {
  InfoCircleOutlined,
  EditOutlined,
  SettingOutlined,
} from "@ant-design/icons";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import statusMapper from "./StatusMapper";
import DispatchAside from "./paymentsNav";
import invoiceApis from "../../api/Invoice/invoice";
import {
  formatCurrency,
  formatCurrency2,
  formatDecimal,
} from "../../utils/Utils";
import PaymentsApprovalDrawer from "./PaymentsApprovalDrawer";
import paymentApis from "../../api/payments/payments";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { fetchSequenceAccess } from "../../store/slices/misc/sequenceAccess";
import TransactionFlowDefaultTemplate from "../others/transactionFlowDefaultTemplate";
import usersApis from "../../api/master/users";
import purchaseOrderCreation from "../../api/purchase-orders/pruchaseOrderCreation";
import sequenceApis from "../../api/master/sequence";
const { Option } = Select;
const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}: any) => {
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={`payableAmount_${record?.invoiceNumber}`}
          style={{ margin: 0 }}
          rules={[
            {
              required: true,
              message: `${title} is required`,
            },
            {
              type: "number",
              min: 1,
              message: `${title} must > 0`,
            },
            {
              type: "number",
              max:
                Number(record?.grossTotal) -
                Number(record?.paidAmount) -
                Number(record?.createdPayableAmount),
              message: `Payable Amt cannot be greater than outstanding Amt`,
            },
          ]}
          initialValue={
            Number(record?.grossTotal) -
            Number(record?.paidAmount) -
            Number(record?.createdPayableAmount)
          }
        >
          <InputNumber
            className="w-100"
            formatter={(value) => {
              const hasDecimal = value.toString().includes(".");
              return value
                ? new Intl.NumberFormat("en-IN", {
                    style: "decimal",
                    minimumFractionDigits: hasDecimal ? 2 : 0,
                    maximumFractionDigits: hasDecimal ? 2 : 0,
                  }).format(value)
                : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }}
            parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
            onKeyPress={(event) => {
              const regex = /^[0-9\b\.]+$/;
              if (!regex.test(event.key)) {
                event.preventDefault();
              }
            }}
            step={0.01}
          />
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const InvoicePayables: FC = () => {
  const [disableSubmit, setDisableSubmit] = useState(false);
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const { data: sequenceAccess } = useSelector(
    (state: any) => state.sequenceAccess,
  );
  const { data: accessibility }: any = useSelector(
    (state: any) => state.accessibility,
  );
  const canPreviewPayment = accessibility?.["Payments"]?.add === 1;
  const [CNError, setCNError] = useState<any>(null);
  const [selectedCNValueTotal, setSelectedCNValueTotal] = useState(0);
  const [selectedCNValueUtilized, setSelectedCNValueUtilized] = useState([]);
  const [advanceAmountTotal, setAdvanceAmountTotal] = useState(0);
  const [advanceAmountError, setAdvanceAmountError] = useState<any>(null);
  const [sm, setSm] = useState(false);
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const [form3] = Form.useForm();
  const [form4] = Form.useForm();
  const [tab, setTab] = useState(null);
  const [matchingLoad, setMatchingLoad] = useState(true);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [filteredData, setFilteredData] = useState<any[]>([]);
  const [editingKeys, setEditingKeys] = useState<string[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedCnKeys, setSelectedCnKeys] = useState<React.Key[]>([]);
  const [advanceAmounts, setAdvanceAmounts] = useState<any>([]);
  const [selectedAdvanceKeys, setSelectedAdvanceKeys] = useState<React.Key[]>(
    [],
  );
  const [editingAdvance, setEditingAdvance] = useState<any>([]);
  const [selectedAdvanceUtilized, setSelectedAdvanceUtilized] = useState<any>(
    [],
  );
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [payableLines, setPayableLines] = useState<any>([]);
  const [approvalRequired, setApprovalRequired] = useState("");
  const [approvals, setApprovals] = useState({
    open: false,
    data: [],
  });
  const [isStrictApproval, setIsStrictApproval] = useState<boolean>(false);
  const [paymentMode, setPaymentMode] = useState<string>("neft");
  const [invoiceData, setInvoiceData] = useState<any>([]);
  const isEditing = (record: any, setSelectedRowKeys: any) => {
    return setSelectedRowKeys.includes(record.invoiceNumber);
  };
  const [editingCn, setEditingCn] = useState<any>([]);
  const isCnEditing = (record: any) => editingCn.includes(record.noteNumber);
  const isAdvanceEditing = (record: any) =>
    editingAdvance.includes(record.orderNumber);
  const [expandedRowKeys, setExpandedRowKeys] = useState<string[]>([]);
  const [supplierList, setSupplierList] = useState<any>([]);
  const [selectedSupplier, setSelectedSupplier] = useState<any>(null);
  const [CN, setCN] = useState<any>([]);
  const [selectedSiteId, setSelectedSiteId] = useState<any>(null);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [siteNameToIdMap, setSiteNameToIdMap] = useState<any>({});
  const [siteList, setSiteList] = useState<any>([]);
  const [selectedSite, setSelectedSite] = useState<any>(null);

  const [activeSequences, setActiveSequences] = useState<any[]>([]);
  const [numberingMode, setNumberingMode] = useState<"auto" | "manual">("auto");
  const [showNumberingModal, setShowNumberingModal] = useState(false);
  const [tempNumberingMode, setTempNumberingMode] = useState<"auto" | "manual">(
    "auto",
  );

  useEffect(() => {
    fetchSupplierList();
    fetchCurrentUser();
  }, []);

  const fetchCurrentUser = async () => {
    try {
      const data = await usersApis.getCurrentUser();
      if (data) {
        setCurrentUser(data);
        // Create mapping from siteName to siteID
        const siteMap: any = {};
        const siteOptions: any = [];
        data?.siteAccessibility?.forEach((item: any) => {
          siteMap[item.siteName] = item.siteID;
          siteOptions.push({
            label: item.siteName,
            value: item.siteID,
          });
        });
        setSiteNameToIdMap(siteMap);
        setSiteList(siteOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSupplierList = async () => {
    try {
      const res = await paymentApis.fetchUniqueSuppliersOfPayableInvoices();
      if (res.status) {
        let options = res.data.map((item: any) => ({
          label: item.supplierName,
          value: item.supplierId,
        }));
        setSupplierList(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    dispatch(fetchSequenceAccess());
  }, [dispatch]);

  const handleExpand = (expanded: boolean, record: any) => {
    if (expanded) {
      setExpandedRowKeys([record.key]); // Only allow one expanded row at a time
      setTab(record.key);
    } else {
      setExpandedRowKeys([]); // Collapse all rows
    }
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const columns: any = [
    {
      title: "Invoice #",
      dataIndex: "invoiceId",
      key: "invoiceId",
      width: 250,
      fixed: "left",
      render: (text: any, record: any) => {
        if (!text && !record.invoiceNumber) return <span>-</span>;
        const invoiceId = text || record.invoiceId;
        const invoiceNumber = record.invoiceNumber;
        return (
          <span
            className="inlineTableCellLink"
            style={{ cursor: "pointer", color: "#2263b3" }}
            onClick={() => {
              if (invoiceNumber) {
                navigate(`/view-invoice/${invoiceNumber}`, {
                  state: { previousPath: "/invoice-payables" },
                });
              }
            }}
          >
            {invoiceId}
          </span>
        );
      },
    },
    {
      title: "Order #",
      dataIndex: "orderId",
      key: "orderId",
      width: 250,
      render: (text: any, record: any) => {
        if (!text && !record.orderNumber) return <span>-</span>;
        const orderId = text || record.orderId;
        const orderNumber = record.orderNumber;
        return (
          <span
            className="inlineTableCellLink"
            style={{ cursor: "pointer", color: "#2263b3" }}
            onClick={() => {
              if (orderNumber) {
                navigate(`/view-purchase-order/${orderNumber}`, {
                  state: { previousPath: "/invoice-payables" },
                });
              }
            }}
          >
            {orderId}
          </span>
        );
      },
    },
    {
      title: "3 Way Match",
      key: "#",
      dataIndex: "threeWayMatch",
      width: 100,
      hidden: true,
      fixed: "left",
      render: (text: any) => {
        const { isThreeWayMatched, message } = text || {};
        if (isThreeWayMatched) {
          return <Badge color="outline-success">Matched</Badge>;
        }
        return <Badge color="outline-danger">Not Matched</Badge>;
      },
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",
      key: "createdDate",
      render: (date: any) => <span>{FormatDate(date)}</span>,
      width: 150,
    },
    {
      title: "Supplier",
      dataIndex: "supplierName",
      key: "supplierName",
      width: 250,
      render: (text: string, record: any, index: any) => {
        return (
          <>
            <span id={`supplierName-tooltip-${index}`}>
              {text?.length > 25 ? `${text?.substring(0, 22)}... ` : text}
            </span>
            {text?.length > 25 && (
              <TooltipComponent
                iconClass="info-circle text-info"
                icon="info"
                id={`supplierName-tooltip-${index}`}
                direction="top"
                text={text}
                containerClassName={""}
              />
            )}
          </>
        );
      },
    },
    {
      title: "Outstanding Amount",
      key: "outstandingAmount",
      width: 180,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(
                Number(record?.additionalCharges) +
                  Number(record?.grossTotal) -
                  Number(record?.paidAmount) -
                  Number(record?.createdPayableAmount),
                "INR",
              )}
              {/* <Tooltip
              title={formatCurrency(
                Number(record?.grossTotal) -
                  Number(record?.paidAmount) -
                  Number(record?.createdPayableAmount),
                "INR"
              )}
            >
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "Payable Amount",
      key: "payableAmount",
      width: 200,
      editable: true,
      render: (text: any, record: any) => {
        return <span></span>;
      },
    },
    {
      title: "Paid Amount",
      key: "paidAmount",
      width: 200,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(record?.paidAmount, "INR")}
              {/* <Tooltip title={formatCurrency(record?.paidAmount, "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "InProcess Amount",
      key: "createdPayableAmount",
      width: 200,
      render: (text: any, record: any) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span>
              {formatCurrency(record?.createdPayableAmount, "INR")}
              {/* <Tooltip
              title={formatCurrency(record?.createdPayableAmount, "INR")}
            >
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip> */}
            </span>
          </div>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "createdUserName",
      key: "createdUserName",
      width: 200,
    },
    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 200,
    },
    {
      title: "GRN Status",
      dataIndex: "deliveryStatus",
      key: "deliveryStatus",
      width: 200,
      render(value: any, record: any, index: any) {
        const grnStatus: any = {
          FullyDelivered: "Fully Delivered",
          PartiallyDelivered: "Partially Delivered",
        };
        return <p className="tb-status">{grnStatus[value] || value}</p>;
      },
    },
    {
      title: "Payment Due Date",
      dataIndex: "dueDate",
      key: "dueDate",
      width: 150,
      render: (date: any) => (
        <span>{date ? dayjs(date).format("DD-MMM-YYYY") : "N/A"}</span>
      ),
    },
    {
      title: "Payment Days",
      dataIndex: "aging",
      key: "aging",
      width: 160,
      render: (text: any, record: any) => {
        //  "dueType": "overDue",
        let dueType = record?.due?.days > 0 ? "overDue" : "due";
        const isHighlighted = dueType == "overDue";
        let placeholder = "";
        if (dueType == "overDue") {
          placeholder =
            "OVERDUE BY " + Math.abs(Number(record?.due?.days)) + " DAYS";
        } else {
          // if (record?.dueType == "Paid") {
          //   placeholder = "PAID";
          // } else {
          if (record?.due?.days == 0) {
            placeholder = "DUE TODAY";
          } else {
            placeholder =
              "DUE IN " + Math.abs(Number(record?.due?.days)) + " DAYS";
          }
          // }
        }
        return (
          <div
            className="align-left"
            style={{
              color: isHighlighted ? "lightcoral" : "green",
              backgroundColor: isHighlighted ? "white" : "inherit",
              padding: "4px",
              borderRadius: "4px",
            }}
          >
            {placeholder}
          </div>
        );
      },
    },
    {
      title: "Status",
      dataIndex: "invoiceStatus",
      key: "invoiceStatus",
      width: 180,
      fixed: "right",
      render: (status: any) => {
        const _status = statusMapper[status]?.seller;
        return (
          <div className="justify-start align-center">
            <h6
              className={`tb-status ms-1`}
              style={{
                color: `${_status?.color}`,
                fontSize: "14px",
              }}
            >
              {_status?.icon} {_status?.title || status}
            </h6>
          </div>
        );
      },
    },
  ];

  const cNColumns: any = [
    {
      title: "Note #",
      dataIndex: "noteId",
      key: "noteId",
      width: 100,
      fixed: "left",
      render: (text: any) => (
        <div className="align-left">
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Note Amount",
      key: "unUtilizedAmount",
      width: 140,
      render: (text: any, record: any) => {
        return (
          <span>
            {formatCurrency2(Number(record?.unUtilizedAmount), "INR")}
            <Tooltip
              title={formatCurrency(Number(record?.unUtilizedAmount), "INR")}
            >
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip>
          </span>
        );
      },
    },
    {
      title: "Utilized Amount",
      key: "utilizedAmount",
      width: 200,
      editable: true,
      render: (text: any, record: any) => {
        return <span></span>;
      },
    },
  ];

  const advanceAmountColumns: any = [
    {
      title: "Order #",
      dataIndex: "orderId",
      key: "orderId",
      width: 200,
      fixed: "left",
      render: (text: any, record: any) => (
        <div className="align-left">
          <span>{text || record.orderId}</span>
        </div>
      ),
    },
    {
      title: "Advance Amount",
      key: "totalBalancedAdvanceAmount",
      width: 180,
      render: (text: any, record: any) => {
        return (
          <span>
            {formatCurrency2(Number(record?.totalBalancedAdvanceAmount), "INR")}
            <Tooltip
              title={formatCurrency(
                Number(record?.totalBalancedAdvanceAmount),
                "INR",
              )}
            >
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip>
          </span>
        );
      },
    },
    {
      title: "Utilized Amount",
      key: "utilizedAmount",
      width: 200,
      editable: true,
      render: (text: any, record: any) => {
        return <span></span>;
      },
    },
  ];
  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    selectedRows: any,
  ) => {
    // Validate site ID consistency
    if (newSelectedRowKeys && newSelectedRowKeys.length > 0) {
      const siteIds = selectedRows.map((row: any) => {
        // Try to get siteId directly, or map from siteName
        return row.siteId || row.siteID || siteNameToIdMap[row.siteName];
      });
      const uniqueSiteIds = Array.from(new Set(siteIds.filter(Boolean)));

      if (uniqueSiteIds.length > 1) {
        Swal.fire({
          title: "Invalid Selection",
          text: "You can only select invoices from the same site. Please deselect invoices from different sites first.",
          icon: "warning",
          confirmButtonText: "OK",
        });
        return; // Don't proceed with selection
      }

      // Set the selected site ID
      if (uniqueSiteIds.length === 1) {
        setSelectedSiteId(uniqueSiteIds[0]);
      }
    } else {
      setSelectedSiteId(null);
    }

    setSelectedRowKeys(newSelectedRowKeys);
    if (!newSelectedRowKeys) {
      editingKeys.forEach((key) => {
        const row = selectedRows.find((item: any) => item.invoiceNumber == key);
        form.setFieldsValue({
          [`payableAmount_${row?.invoiceNumber}`]:
            Number(row?.additionalCharges) +
            Number(row?.grossTotal) -
            Number(row?.paidAmount) -
            Number(row?.createdPayableAmount),
        });
      });
      setEditingKeys(() => []);
      form.resetFields();
    }
    const unSelectedRowKeys = selectedRowKeys.filter(
      (key) => !newSelectedRowKeys.includes(key),
    );
    unSelectedRowKeys?.forEach((key) => {
      const row = selectedRows.find((item: any) => item.invoiceNumber == key);
      form.setFieldsValue({
        [`payableAmount_${row?.invoiceNumber}`]:
          Number(row?.additionalCharges) +
          Number(row?.grossTotal) -
          Number(row?.paidAmount) -
          Number(row?.createdPayableAmount),
      });
    });
    const editableRowKeys: any = [];
    newSelectedRowKeys?.forEach((key) => {
      const row = selectedRows.find((item: any) => item.invoiceNumber == key);
      if (row) {
        form.setFieldsValue({ ...row });
        editableRowKeys.push(row?.invoiceNumber);
      }
    });
    setEditingKeys(editableRowKeys);
    setFilteredData(selectedRows);
  };

  const onCNSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedCnKeys(newSelectedRowKeys);
    if (!newSelectedRowKeys) {
      editingCn.forEach((key: any) => {
        const row = CN.find((item: any) => item.noteNumber == key);
        form3.setFieldsValue({
          [`utilizedAmount_${row.noteNumber}`]:
            Number(row?.noteAmount) - Number(row?.utilizedAmount),
        });
      });
      setEditingCn(() => []);
      form3.resetFields();
    }
    const unSelectedRowKeys = selectedCnKeys.filter(
      (key) => !newSelectedRowKeys.includes(key),
    );
    unSelectedRowKeys?.forEach((key) => {
      const row = CN.find((item: any) => item.noteNumber == key);
      form3.setFieldsValue({
        [`utilizedAmount_${row.noteNumber}`]:
          Number(row?.noteAmount) - Number(row?.utilizedAmount),
      });
    });
    const editableRowKeys: any = [];
    newSelectedRowKeys?.forEach((key) => {
      const row = CN.find((item: any) => item.noteNumber == key);
      if (row) {
        form3.setFieldsValue({ ...row });
        editableRowKeys.push(row.noteNumber);
      }
    });
    setEditingCn(editableRowKeys);
  };

  const fetchAllOrgUnUtilizedCreditDebitNotes = async () => {
    try {
      const res =
        await paymentApis.fetchAllOrgUnUtilizedCreditDebitNotes(
          selectedSupplier,
        );
      const { data, status, message } = res;
      if (status) {
        setCN(data);
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const showDrawer = async () => {
    try {
      const rows = await form.validateFields();
      fetchAllOrgUnUtilizedCreditDebitNotes();
      const invoiceLines: any = [];
      filteredData?.forEach((item: any) => {
        if (
          editingKeys.includes(item.invoiceNumber) &&
          rows[`payableAmount_` + item.invoiceNumber] > 0
        ) {
          const payableAmount = Number(
            rows[`payableAmount_` + item.invoiceNumber],
          );
          invoiceLines.push({
            ...item,
            payableAmount,
          });
        }
      });
      if (invoiceLines.length > 0) {
        setTab(invoiceLines[0]?.invoiceNumber);
      }
      setPayableLines(invoiceLines);

      // Open drawer first (non-blocking)
      setDrawerVisible(true);

      // Extract order numbers from selected invoices and call API (non-blocking)
      const orderNumbersArray = filteredData
        ?.filter(
          (item: any) =>
            editingKeys.includes(item.invoiceNumber) &&
            rows[`payableAmount_` + item.invoiceNumber] > 0,
        )
        ?.map((item: any) => item.orderNumber || item.orderId)
        ?.filter((orderNum: any) => orderNum); // Remove any null/undefined values

      // Format order numbers: single without quotes, multiple as comma-separated string
      if (orderNumbersArray && orderNumbersArray.length > 0) {
        let orderNumbers: string;
        if (orderNumbersArray.length === 1) {
          // Single order: no quotes
          orderNumbers = orderNumbersArray[0];
        } else {
          // Multiple orders: simple comma-separated string (e.g., "49645,49573,49639")
          orderNumbers = orderNumbersArray.join(",");
        }

        // Call API asynchronously without blocking
        purchaseOrderCreation
          .fetchMultipleOrdersWithAdvancedUtilizedAmounts(orderNumbers)
          .then((response) => {
            console.log("Advanced utilized amounts response:", response);
            if (response?.status && response?.data) {
              setAdvanceAmounts(response.data);
            }
          })
          .catch((error) => {
            console.error("Error fetching advanced utilized amounts:", error);
          });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (tab) {
      setMatchingLoad(true);
      fetchInvoiceDetails(tab);
    }
  }, [tab]);

  // Calculate advance amount total from selected advance utilized amounts
  useEffect(() => {
    if (selectedAdvanceUtilized && selectedAdvanceUtilized.length > 0) {
      const totalAdvanceAmount = selectedAdvanceUtilized.reduce(
        (sum: number, item: any) => sum + Number(item?.utilizedAmount || 0),
        0,
      );
      setAdvanceAmountTotal(totalAdvanceAmount);
    } else {
      setAdvanceAmountTotal(0);
    }
  }, [selectedAdvanceUtilized]);

  // Validate combined Credit Note + Advance Amount against Payable Amount
  useEffect(() => {
    if (payableLines && payableLines.length > 0) {
      const totalPayableAmount = payableLines.reduce(
        (a: any, b: any) => a + Number(b?.payableAmount),
        0,
      );
      const combinedTotal = selectedCNValueTotal + advanceAmountTotal;

      if (combinedTotal > totalPayableAmount) {
        setAdvanceAmountError(
          "Credit Note Amount and Advance Amount together cannot be greater than Payable Amount",
        );
        if (selectedCNValueTotal > 0) {
          setCNError(
            "Credit Note Amount and Advance Amount together cannot be greater than Payable Amount",
          );
        }
      } else {
        setAdvanceAmountError(null);
        // Clear CNError if it was set by this validation
        setCNError((prevError: any) => {
          if (prevError && prevError.includes("together cannot be greater")) {
            return null;
          }
          return prevError;
        });
      }
    } else {
      setAdvanceAmountError(null);
    }
  }, [payableLines, selectedCNValueTotal, advanceAmountTotal]);

  const fetchInvoiceDetails = async (invoiceNumber: any) => {
    try {
      const res = await invoiceApis.fetchInvoice(invoiceNumber);
      const { data, status, message } = res;
      if (status) {
        setInvoiceData(data?.invoiceLines);
        setMatchingLoad(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const cnRowSelection = {
    selectedRowKeys: selectedCnKeys,
    onChange: onCNSelectChange,
  };

  const onAdvanceSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedAdvanceKeys(newSelectedRowKeys);
    if (!newSelectedRowKeys) {
      editingAdvance.forEach((key: any) => {
        const row = advanceAmounts.find((item: any) => item.orderNumber == key);
        form4.setFieldsValue({
          [`utilizedAdvanceAmount_${row.orderNumber}`]:
            Number(row?.totalBalancedAdvanceAmount) || 0,
        });
      });
      setEditingAdvance(() => []);
      form4.resetFields();
    }
    const unSelectedRowKeys = selectedAdvanceKeys.filter(
      (key) => !newSelectedRowKeys.includes(key),
    );
    unSelectedRowKeys?.forEach((key) => {
      const row = advanceAmounts.find((item: any) => item.orderNumber == key);
      form4.setFieldsValue({
        [`utilizedAdvanceAmount_${row.orderNumber}`]:
          Number(row?.totalBalancedAdvanceAmount) || 0,
      });
    });
    const editableRowKeys: any = [];
    newSelectedRowKeys?.forEach((key) => {
      const row = advanceAmounts.find((item: any) => item.orderNumber == key);
      if (row) {
        form4.setFieldsValue({
          [`utilizedAdvanceAmount_${row.orderNumber}`]:
            Number(row?.totalBalancedAdvanceAmount) || 0,
        });
        editableRowKeys.push(row.orderNumber);
      }
    });
    setEditingAdvance(editableRowKeys);
  };

  const advanceRowSelection = {
    selectedRowKeys: selectedAdvanceKeys,
    onChange: onAdvanceSelectChange,
  };

  const submit = async (data: any) => {
    try {
      // Validate combined Credit Note + Advance Amount before submission
      const totalPayableAmount = payableLines.reduce(
        (a: any, b: any) => a + Number(b?.payableAmount),
        0,
      );
      const combinedTotal = selectedCNValueTotal + advanceAmountTotal;

      if (combinedTotal > totalPayableAmount) {
        Swal.fire(
          "Validation Error",
          "Credit Note Amount and Advance Amount together cannot be greater than Payable Amount",
          "error",
        );
        setDisableSubmit(false);
        return;
      }

      const lineItems: any = payableLines?.map((item: any) => {
        return {
          invoiceNumber: item.invoiceNumber,
          payableAmount: item.payableAmount,
        };
      });

      // Calculate total advance amount utilized
      const totalAdvanceAmount = selectedAdvanceUtilized.reduce(
        (sum: number, item: any) => sum + Number(item?.utilizedAmount || 0),
        0,
      );

      // Determine if approvals are required
      const requiresApproval = data?.approvals == "true";
      let paymentApprovalHierarchy: any = [];

      // When autoRelease is true, transactionNumber is required (except for cash payments)
      if (
        !requiresApproval &&
        !data?.transactionNumber &&
        data?.paymentMode !== "cash"
      ) {
        Swal.fire(
          "Validation Error",
          "Transaction Number/UTR/Cheque Number is required",
          "error",
        );
        setDisableSubmit(false);
        return;
      }

      // When autoRelease is true, bank name and account number are required (except for cash payments)
      if (!requiresApproval && data?.paymentMode !== "cash") {
        if (!data?.financialInstitutionName) {
          Swal.fire("Validation Error", "Bank Name is required", "error");
          setDisableSubmit(false);
          return;
        }
        if (!data?.bankAccountNumber) {
          Swal.fire(
            "Validation Error",
            "Bank Account Number is required",
            "error",
          );
          setDisableSubmit(false);
          return;
        }
      }

      // Build paymentData object - ensure no duplicate fields
      // Only include fields from form data, don't add extra fields
      // Note: advanceUtlizedAmounts should NOT be inside paymentData, only at top level
      const paymentData: any = {
        paymentDate: data?.paymentDate?.format("YYYY-MM-DD"),
        autoRelease: !requiresApproval,
        selfPayment: true,
        orgId: currentUser?.orgid || currentUser?.orgId,
        advanceAmount: totalAdvanceAmount,
        remarks: data?.remarks || "",
        lineItems,
        isStrictApproval: Boolean(isStrictApproval),
      };

      // Add paymentId only if provided in form data (when sequence access is not available)
      if (numberingMode === "manual" && data?.paymentId) {
        paymentData.paymentId = data?.paymentId;
      }

      // Set approval hierarchy and payment details based on approval requirement
      if (requiresApproval) {
        paymentApprovalHierarchy = approvals?.data || [];
      } else {
        // When autoRelease is true, include payment mode and transaction number
        if (data?.paymentMode) {
          paymentData.paymentMode = data?.paymentMode;
        }
        if (data?.transactionNumber) {
          paymentData.transactionNumber = data?.transactionNumber?.toString();
        }
        if (data?.financialInstitutionName) {
          paymentData.financialInstitutionName = data?.financialInstitutionName;
        }
        if (data?.bankAccountNumber) {
          paymentData.bankAccountNumber = data?.bankAccountNumber;
        }
      }

      // Prepare the final payload matching the exact API format
      const payload = {
        paymentData,
        creditDebitNotes: selectedCNValueUtilized || [],
        advanceUtlizedAmounts: selectedAdvanceUtilized || [],
        paymentApprovalHierarchy: paymentApprovalHierarchy || [],
      };

      const res = await paymentApis.submitPayment(payload);
      const { status, message, data: _data } = res;
      if (status) {
        Swal.fire("payment created", _data, "success");
        navigate("/view-payments");
      } else {
        Swal.fire("Error", message, "error");
      }
    } catch (error) {}
    setDisableSubmit(false);
  };

  const invoiceColumns: any = [
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      width: 200,
      fixed: "left",
      render: (material: any) => <div className="align-left">{material}</div>,
    },
    {
      title: "Ordered Qty",
      dataIndex: "quantityOrdered",
      key: "quantityOrdered",
      width: 150,
      render: (text: any, record: any) => (
        <div className="align-left">{Number(text) + " " + record?.uom}</div>
      ),
    },
    {
      title: "Delivered Qty",
      dataIndex: "quantityDelivered",
      key: "quantityDelivered",
      width: 150,
      render: (text: any, record: any) => {
        const isHighlighted = Number(record?.quantityOrdered) < Number(text);
        return (
          <div
            className="align-left"
            style={{
              backgroundColor: isHighlighted ? "lightcoral" : "transparent", // Highlight with light red if quantities differ
              color: isHighlighted ? "white" : "inherit", // Optionally change text color when highlighted
              padding: "4px",
              borderRadius: "4px",
            }}
          >
            {Number(text) + " " + record?.uom}
          </div>
        );
      },
    },
    {
      title: "Invoiced Qty",
      dataIndex: "quantityInvoiced",
      key: "quantityInvoiced",
      width: 150,
      render: (text: any, record: any) => {
        const isHighlighted = Number(record?.quantityDelivered) != Number(text);
        return (
          <div
            className="align-left"
            style={{
              backgroundColor: isHighlighted ? "lightcoral" : "transparent", // light red color for highlighting
              color: isHighlighted ? "white" : "inherit", // optional: change text color when highlighted
              padding: "4px",
              borderRadius: "4px",
            }}
          >
            {Number(text) + " " + record?.uom}
          </div>
        );
      },
    },
    {
      title: "Order Price",
      dataIndex: "orderPrice",
      key: "orderPrice",
      width: 150,
      render: (text: any) => (
        <>
          {formatCurrency2(Number(text), "INR")}
          <span>
            <Tooltip title={formatCurrency(Number(text), "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip>
          </span>
        </>
      ),
    },
    {
      title: "Unit Price",
      dataIndex: "unitPrice",
      key: "unitPrice",
      width: 150,
      render: (text: any, record: any) => {
        const isHighlighted = Number(record?.orderPrice) < Number(text);
        return (
          <div
            style={{
              backgroundColor: isHighlighted ? "lightcoral" : "transparent", // Highlight if orderPrice < unitPrice
              color: isHighlighted ? "white" : "inherit", // Optional: change text color when highlighted
              padding: "4px",
              borderRadius: "4px",
            }}
          >
            {formatCurrency2(Number(text), "INR")}
            <span>
              <Tooltip title={formatCurrency(Number(text), "INR")}>
                <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
              </Tooltip>
            </span>
          </div>
        );
      },
    },
    {
      title: "Need By Date",
      dataIndex: "needByDate",
      key: "needByDate",
      width: 150,
      render: (text: any) => dayjs(text).format("DD-MMM-YYYY"),
    },
    {
      title: "Basic Amount",
      dataIndex: "basicAmount",
      key: "basicAmount",
      width: 150,
      render: (text: any) => (
        <>
          {formatCurrency2(Number(text), "INR")}
          <span>
            <Tooltip title={formatCurrency(Number(text), "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip>
          </span>
        </>
      ),
    },
    {
      title: "Net Amount",
      dataIndex: "netAmount",
      key: "netAmount",
      width: 150,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          <span>{formatCurrency(text, "INR")}</span>
        </div>
      ),
    },
    {
      title: "CGST",
      children: [
        {
          title: "%",
          dataIndex: "cgstPercentage",
          key: "cgstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${
              Number(record?.sgst) && Number(record?.cgst)
                ? Number(text) + "%"
                : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "cgst",
          key: "cgst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {Number(record?.sgst) && Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "SGST",
      children: [
        {
          title: "%",
          dataIndex: "sgstPercentage",
          key: "sgstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${
              Number(record?.sgst) && Number(record?.cgst)
                ? Number(text) + "%"
                : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "sgst",
          key: "sgst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {Number(record?.sgst) && Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "IGST",
      children: [
        {
          title: "%",
          dataIndex: "igstPercentage",
          key: "igstPercentage",
          width: 100,
          render: (text: any, record: any) =>
            `${
              !Number(record?.sgst) && !Number(record?.cgst)
                ? Number(text) + "%"
                : "N/A"
            }`,
        },
        {
          title: "Amount",
          dataIndex: "igst",
          key: "igst",
          width: 150,
          render: (text: any, record: any) => (
            <div style={{ textAlign: "right" }}>
              <span>
                {!Number(record?.sgst) && !Number(record?.cgst)
                  ? formatCurrency(text, "INR")
                  : "N/A"}
              </span>
            </div>
          ),
        },
      ],
    },
    {
      title: "Gross Total",
      dataIndex: "grossTotal",
      key: "grossTotal",
      width: 150,
      render: (text: any) => (
        <>
          {formatCurrency2(Number(text), "INR")}
          <span>
            <Tooltip title={formatCurrency(Number(text), "INR")}>
              <InfoCircleOutlined style={{ marginLeft: 8, fontSize: 12 }} />
            </Tooltip>
          </span>
        </>
      ),
    },
    // {
    //   title: "Status",
    //   dataIndex: "status",
    //   key: "status",
    //   width: 150,
    //   render: (text: any) => <div>{text}</div>,
    // },
  ];

  const EditCN = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }: any) => {
    const handleBlur = (value: number) => {
      form3.submit();
    };

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={`utilizedAmount_${record.noteNumber}`}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `${title} is required`,
              },
              {
                type: "number",
                min: 0.01,
                message: `${title} must > 0`,
              },
              {
                type: "number",
                max: Number(record?.unUtilizedAmount),
                message: `${title} must <= ${formatCurrency(
                  Number(record?.unUtilizedAmount),
                  "INR",
                )}`,
              },
            ]}
            initialValue={Number(record?.unUtilizedAmount)}
          >
            <InputNumber
              className="w-100"
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
              onKeyPress={(event) => {
                const regex = /^[0-9\b\.]+$/;
                if (!regex.test(event.key)) {
                  event.preventDefault();
                }
              }}
              step={0.01}
              onBlur={(e: any) => handleBlur(e?.target?.value)} // Use onBlur instead of onChange
            />
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const EditAdvance = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }: any) => {
    const handleBlur = (value: number) => {
      form4.submit();
    };

    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={`utilizedAdvanceAmount_${record.orderNumber}`}
            style={{ margin: 0 }}
            rules={[
              {
                required: true,
                message: `${title} is required`,
              },
              {
                type: "number",
                min: 0.01,
                message: `${title} must > 0`,
              },
              {
                type: "number",
                max: Number(record?.totalBalancedAdvanceAmount),
                message: `${title} must <= ${formatCurrency(
                  Number(record?.totalBalancedAdvanceAmount),
                  "INR",
                )}`,
              },
            ]}
            initialValue={Number(record?.totalBalancedAdvanceAmount) || 0}
          >
            <InputNumber
              className="w-100"
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value: any) => value.replace(/\$\s?|(,*)/g, "")}
              onKeyPress={(event) => {
                const regex = /^[0-9\b\.]+$/;
                if (!regex.test(event.key)) {
                  event.preventDefault();
                }
              }}
              step={0.01}
              onBlur={(e: any) => handleBlur(e?.target?.value)}
            />
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };

  const fetchPaymentSequenceAccess = async () => {
    try {
      const response = await sequenceApis.fetchSequence();
      const { data } = response;
      const today = new Date();
      const _sequenceAccess = data?.filter(
        (item: any) =>
          item.moduleName === "Payments" &&
          new Date(item.endDate) > today &&
          item.status === "Active",
      );
      setActiveSequences(_sequenceAccess || []);

      // Set initial numbering mode based on available sequences
      if (_sequenceAccess && _sequenceAccess.length > 0 && selectedSiteId) {
        const siteHasSequence = _sequenceAccess.some(
          (seq: any) => seq.siteId?.toString() === selectedSiteId?.toString(),
        );
        setNumberingMode(siteHasSequence ? "auto" : "manual");
      } else {
        setNumberingMode("manual");
      }
    } catch (error: any) {
      setActiveSequences([]);
      setNumberingMode("manual");
    }
  };

  // Fetch sequences when site changes
  useEffect(() => {
    if (selectedSiteId) {
      fetchPaymentSequenceAccess();
    } else {
      setActiveSequences([]);
    }
  }, [selectedSiteId]);

  const getCurrentSiteSequence = useCallback(() => {
    if (!selectedSiteId || activeSequences.length === 0) return null;
    const siteSequence = activeSequences.find(
      (seq) =>
        seq.level === "Site" &&
        seq.siteId?.toString() === selectedSiteId?.toString(),
    );
    if (siteSequence) return siteSequence;
    const orgSequence = activeSequences.find((seq) => seq.level === "Org");
    if (orgSequence) return orgSequence;
    return null;
  }, [selectedSiteId, activeSequences]);

  const currentSiteSequence = getCurrentSiteSequence();
  const canAuto = !!selectedSiteId && !!currentSiteSequence;

  // Auto-generate number when in auto mode
  useEffect(() => {
    const existingValue = form2.getFieldValue("paymentId");

    if (numberingMode === "auto" && currentSiteSequence && !existingValue) {
      const { prefix } = currentSiteSequence;
      const paymentNumber = `${prefix}`;
      form2.setFieldValue("paymentId", paymentNumber);
    }
  }, [numberingMode, currentSiteSequence, form2]);

  const prevSiteRef = useRef();
  // Set initial mode based on site selection
  useEffect(() => {
    const currentSiteId = selectedSiteId;
    const prevSite = prevSiteRef.current;

    // Only run if site actually changed
    if (prevSite && prevSite !== currentSiteId) {
      form2.setFieldValue("paymentId", "");
    }

    if (!currentSiteId) {
      setNumberingMode("manual");
    } else {
      const siteSequence = getCurrentSiteSequence();
      setNumberingMode(siteSequence ? "auto" : "manual");
    }

    prevSiteRef.current = currentSiteId;
  }, [selectedSiteId]);

  return (
    <>
      <Head title="Invoice Payables - View" />

      <TransactionFlowDefaultTemplate
        moduleKey="payments-upload"
        title="Invoice Payables"
        columns={columns?.map((col: any) => {
          if (!col.editable) {
            return col;
          }
          return {
            ...col,
            onCell: (record: any) => ({
              record,
              inputType: col.key === "payableAmount" ? "number" : "text",
              dataIndex: col.key,
              title: col.title,
              editing: isEditing(record, selectedRowKeys),
            }),
          };
        })}
        form={form}
        sideNavigation={
          <div
            className={`card-aside card-aside-left user-aside toggle-slide toggle-slide-left toggle-break-lg ${
              sm ? "content-active" : ""
            }`}
          >
            <DispatchAside updateSm={setSm} sm={sm} />
          </div>
        }
        rowSelection={selectedSupplier != null ? rowSelection : undefined}
        components={
          selectedSupplier
            ? {
                body: {
                  cell: EditableCell,
                },
              }
            : undefined
        }
        selectFilters={[
          {
            title: "Select Supplier",
            placeholder: "Select Supplier",
            options: supplierList,
            onChange: (data: any) => {
              onSelectChange([], []);
              setSelectedSupplier(data);
            },
          },
          {
            title: "Select Site",
            placeholder: "Select Site",
            options: siteList,
            onChange: (data: any) => {
              onSelectChange([], []);
              setSelectedSite(data);
            },
          },
        ]}
        topRightJSX={
          selectedRowKeys?.length != 0 && canPreviewPayment ? (
            <Button
              color="primary"
              className="m-0"
              style={{ height: 40, width: 150 }}
              onClick={showDrawer}
            >
              Preview Payment
            </Button>
          ) : (
            <></>
          )
        }
        extra={{
          tableScrollX: 1100,
          bulkUpload: true,
        }}
      />
      {drawerVisible && (
        <Drawer
          title={
            <div className="d-flex justify-content-between align-items-center">
              <strong>Payment Preview</strong>
              <div style={{ textAlign: "right" }}>
                {disableSubmit ? (
                  <Button color="primary" type="button">
                    <Spinner size="sm" color="light" />
                  </Button>
                ) : (
                  <Button
                    onClick={() => {
                      form2.submit();
                    }}
                    color="primary"
                    className="m-3 mt-0 mb-0"
                    disabled={CNError || advanceAmountError ? true : false}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </div>
          }
          placement="right"
          onClose={() => {
            setDrawerVisible(false);
            setAdvanceAmountTotal(0);
            setAdvanceAmountError(null);
            setAdvanceAmounts([]);
            setSelectedAdvanceKeys([]);
            setEditingAdvance([]);
            setSelectedAdvanceUtilized([]);
            form4.resetFields();
          }}
          open={drawerVisible}
          width="85vw"
          style={{
            position: "absolute",
            zIndex: 1100,
          }}
          styles={{ body: { paddingBottom: 80 } }}
        >
          <Form
            form={form2}
            layout="vertical"
            onFinish={(data) => {
              setDisableSubmit(true);
              Swal.fire({
                title: "Are you sure?",
                text: "your are about to make an payment for selected invoices",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, Create !",
              }).then((result) => {
                if (result.isConfirmed) {
                  submit(data);
                } else {
                  setDisableSubmit(false);
                }
              });
            }}
            requiredMark={true}
          >
            <h6 className="d-flex justify-content-between">
              <div>Invoice Payables</div>
              <div className="p-3 pt-0 pb-0">
                <div className="w-100">
                  <div className="d-flex justify-content-between">
                    <div className="justify-end">
                      <strong>Payable Amount Total &nbsp; &nbsp; </strong>
                    </div>
                    <strong className="fw-bold">
                      {formatCurrency(
                        payableLines.reduce(
                          (a: any, b: any) => a + Number(b?.payableAmount),
                          0,
                        ),
                        "INR",
                      )}
                    </strong>
                  </div>
                </div>
              </div>
            </h6>
            <div className="table-responsive poTable">
              <div
                style={{
                  width: screenSize - 320 + "px",
                  margin: "0px auto 15px auto",
                }}
              >
                <Table
                  className="customTable"
                  columns={columns.map((col: any) => {
                    if (col.key == "payableAmount") {
                      return {
                        ...col,
                        editable: false,
                        render: (text: any, record: any) =>
                          `${formatCurrency(
                            Number(record?.payableAmount),
                            "INR",
                          )}`,
                      };
                    } else if (col.dataIndex === "invoiceStatus") {
                      return {
                        title: "Status",
                        dataIndex: "invoiceStatus",
                        key: "invoiceStatus",
                        width: 200,
                        render: (status: any) => {
                          const _status = statusMapper[status]?.seller;
                          return (
                            <div className="justify-start align-center">
                              <h6
                                className={`tb-status ms-1`}
                                style={{
                                  color: `${_status?.color}`,
                                  fontSize: "14px",
                                }}
                              >
                                {_status?.icon} {_status?.title || status}
                              </h6>
                            </div>
                          );
                        },
                      };
                    } else if (col.dataIndex === "threeWayMatch") {
                      return {
                        ...col,
                        hidden: false,
                      };
                    }
                    return {
                      ...col,
                    };
                  })}
                  dataSource={payableLines?.map((item: any) => ({
                    ...item,
                    key: item.invoiceNumber,
                  }))}
                  scroll={{ x: 1000 }}
                  bordered
                  size="middle"
                  pagination={false}
                  expandable={{
                    onExpand: handleExpand,
                    expandedRowKeys: Array.isArray(expandedRowKeys)
                      ? expandedRowKeys
                      : [],
                    expandedRowRender: (record: any) => (
                      <div>
                        {matchingLoad ? (
                          <>
                            <Flex
                              align="center"
                              gap="middle"
                              style={{ height: "200px" }}
                            >
                              <Spin size="small" className="m-auto" />
                            </Flex>
                          </>
                        ) : (
                          <div className="table-responsive poTable p-0 m-0">
                            <div
                              style={{
                                width: screenSize - 400 + "px",
                                minHeight: "200px",
                                padding: "0px",
                              }}
                              className="m-auto"
                            >
                              <p className="fw-bold mb-0">
                                {record?.threeWayMatch?.message}
                              </p>
                              <Table
                                className="customTable m-0 p-0 custom-innerTable"
                                columns={invoiceColumns}
                                dataSource={invoiceData}
                                scroll={{ x: 1000 }}
                                bordered
                                size="middle"
                                pagination={false}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ),
                  }}
                />
              </div>
            </div>

            {approvalRequired == "false" ? (
              <React.Fragment>
                <div className="table-responsive poTable">
                  <div
                    style={{
                      width: screenSize - 320 + "px",
                      margin: "0px auto 15px auto",
                    }}
                  >
                    <Form
                      form={form3}
                      component={false}
                      onFinish={(data) => {
                        console.log("data", data);

                        let selectedCNValueTotal = 0;
                        const _selectedCNValues: any = [];
                        Object.keys(data).map((key) => {
                          if (key.includes("utilizedAmount")) {
                            selectedCNValueTotal += Number(data[key]);
                            _selectedCNValues.push({
                              noteNumber: Number(key.split("_")[1]),
                              utilizedAmount: Number(data[key]),
                            });
                          }
                        });

                        setSelectedCNValueTotal(selectedCNValueTotal);
                        const totalPayableAmount = payableLines.reduce(
                          (a: any, b: any) => a + Number(b?.payableAmount),
                          0,
                        );
                        const combinedTotal =
                          selectedCNValueTotal + advanceAmountTotal;

                        if (combinedTotal > totalPayableAmount) {
                          setCNError(
                            "Credit Note Amount and Advance Amount together cannot be greater than Payable Amount",
                          );
                        } else {
                          // Clear error if it was set by this validation
                          if (
                            CNError &&
                            CNError.includes("together cannot be greater")
                          ) {
                            setCNError(null);
                          }
                        }
                        setSelectedCNValueUtilized(_selectedCNValues);
                      }}
                    >
                      <Table
                        title={() => (
                          <div className="d-flex justify-content-between">
                            {CNError ? (
                              <strong style={{ color: "red" }}>
                                {CNError}
                              </strong>
                            ) : (
                              <strong>Select Credit Notes (if needed)</strong>
                            )}
                            {selectedCnKeys.length > 0 && (
                              <Button
                                color="primary"
                                className="m-0"
                                style={{ height: "30px" }}
                                onClick={() => {
                                  form3.submit();
                                }}
                              >
                                Use
                              </Button>
                            )}
                          </div>
                        )}
                        className="customTable"
                        rowSelection={cnRowSelection}
                        columns={cNColumns?.map((col: any) => {
                          if (!col.editable) {
                            return col;
                          }
                          return {
                            ...col,
                            onCell: (record: any) => ({
                              record,
                              inputType: "number",
                              dataIndex: col.dataIndex,
                              title: col.title,
                              editing: isCnEditing(record),
                            }),
                          };
                        })}
                        dataSource={CN?.map((field: any) => {
                          return {
                            ...field,
                            key: field.noteNumber,
                          };
                        })}
                        scroll={{ x: "max-content" }}
                        bordered
                        size="small"
                        pagination={false}
                        components={{
                          body: {
                            cell: EditCN,
                          },
                        }}
                      />
                    </Form>
                  </div>
                </div>

                {advanceAmounts && advanceAmounts.length > 0 ? (
                  <div className="table-responsive poTable">
                    <div
                      style={{
                        width: screenSize - 320 + "px",
                        margin: "0px auto 15px auto",
                      }}
                    >
                      <Form
                        form={form4}
                        component={false}
                        onFinish={(data) => {
                          const _selectedAdvanceValues: any = [];
                          let totalAdvanceAmount = 0;
                          Object.keys(data).map((key) => {
                            if (key.includes("utilizedAdvanceAmount")) {
                              const orderNumber = Number(key.split("_")[1]);
                              const utilizedAmount = Number(data[key]);
                              totalAdvanceAmount += utilizedAmount;
                              _selectedAdvanceValues.push({
                                orderNumber: orderNumber,
                                utilizedAmount: utilizedAmount,
                              });
                            }
                          });

                          // Validate combined total
                          const totalPayableAmount = payableLines.reduce(
                            (a: any, b: any) => a + Number(b?.payableAmount),
                            0,
                          );
                          const combinedTotal =
                            selectedCNValueTotal + totalAdvanceAmount;

                          if (combinedTotal > totalPayableAmount) {
                            setAdvanceAmountError(
                              "Credit Note Amount and Advance Amount together cannot be greater than Payable Amount",
                            );
                            if (selectedCNValueTotal > 0) {
                              setCNError(
                                "Credit Note Amount and Advance Amount together cannot be greater than Payable Amount",
                              );
                            }
                          } else {
                            setAdvanceAmountError(null);
                            // Only clear CNError if it was set by this validation
                            if (
                              CNError &&
                              CNError.includes("together cannot be greater")
                            ) {
                              setCNError(null);
                            }
                          }

                          setSelectedAdvanceUtilized(_selectedAdvanceValues);
                        }}
                      >
                        <Table
                          title={() => (
                            <div className="d-flex justify-content-between">
                              {advanceAmountError ? (
                                <strong style={{ color: "red" }}>
                                  {advanceAmountError}
                                </strong>
                              ) : (
                                <strong>
                                  Select Advance Amounts (if needed)
                                </strong>
                              )}
                              {selectedAdvanceKeys.length > 0 && (
                                <Button
                                  color="primary"
                                  className="m-0"
                                  style={{ height: "30px" }}
                                  onClick={() => {
                                    form4.submit();
                                  }}
                                >
                                  Use
                                </Button>
                              )}
                            </div>
                          )}
                          className="customTable"
                          rowSelection={advanceRowSelection}
                          columns={advanceAmountColumns?.map((col: any) => {
                            if (!col.editable) {
                              return col;
                            }
                            return {
                              ...col,
                              onCell: (record: any) => ({
                                record,
                                inputType: "number",
                                dataIndex: col.dataIndex,
                                title: col.title,
                                editing: isAdvanceEditing(record),
                              }),
                            };
                          })}
                          dataSource={advanceAmounts?.map((field: any) => {
                            return {
                              ...field,
                              key: field.orderNumber,
                            };
                          })}
                          scroll={{ x: "max-content" }}
                          bordered
                          size="small"
                          pagination={false}
                          components={{
                            body: {
                              cell: EditAdvance,
                            },
                          }}
                        />
                      </Form>
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {/* Footer Summary */}
                <div className="table-responsive poTable">
                  <div
                    style={{
                      width: screenSize - 320 + "px",
                      margin: "0px auto 15px auto",
                    }}
                  >
                    <Card className="mb-3">
                      {(() => {
                        const totalPayableAmount = payableLines.reduce(
                          (a: any, b: any) => a + Number(b?.payableAmount),
                          0,
                        );
                        // Calculate advance amount utilized from selectedAdvanceUtilized (similar to credit notes)
                        const advanceAmountUtilized =
                          selectedAdvanceUtilized.reduce(
                            (sum: number, item: any) =>
                              sum + Number(item?.utilizedAmount || 0),
                            0,
                          );
                        const remainingAmount =
                          totalPayableAmount -
                          selectedCNValueTotal -
                          advanceAmountUtilized;
                        return (
                          <div className="row">
                            <Col md={3} className="text-center p-3">
                              <div>
                                <div
                                  className="text-muted mb-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  Payable Amount
                                </div>
                                <div
                                  className="fw-bold"
                                  style={{ fontSize: "16px" }}
                                >
                                  {formatCurrency(totalPayableAmount, "INR")}
                                </div>
                              </div>
                            </Col>
                            <Col md={3} className="text-center p-3">
                              <div>
                                <div
                                  className="text-muted mb-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  Credit Note Amount
                                </div>
                                <div
                                  className="fw-bold"
                                  style={{ fontSize: "16px" }}
                                >
                                  {formatCurrency(selectedCNValueTotal, "INR")}
                                </div>
                              </div>
                            </Col>
                            <Col md={3} className="text-center p-3">
                              <div>
                                <div
                                  className="text-muted mb-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  Advance Amount
                                </div>
                                <div
                                  className="fw-bold"
                                  style={{
                                    fontSize: "16px",
                                    color: advanceAmountError
                                      ? "red"
                                      : "inherit",
                                  }}
                                >
                                  {formatCurrency(advanceAmountUtilized, "INR")}
                                </div>
                                {/* {advanceAmountError && (
                                  <div className="mt-1" style={{ color: "red", fontSize: "11px" }}>
                                    {advanceAmountError}
                                  </div>
                                )} */}
                              </div>
                            </Col>
                            <Col md={3} className="text-center p-3">
                              <div>
                                <div
                                  className="text-muted mb-2"
                                  style={{ fontSize: "12px" }}
                                >
                                  Remaining Amount
                                </div>
                                <div
                                  className="fw-bold"
                                  style={{ fontSize: "16px" }}
                                >
                                  {formatCurrency(remainingAmount, "INR")}
                                </div>
                              </div>
                            </Col>
                          </div>
                        );
                      })()}
                    </Card>
                  </div>
                </div>
              </React.Fragment>
            ) : (
              <></>
            )}

            <div className="">
              <div className="tab-content mt-0 w-70 paddingLeft10 m-auto">
                <div className="tab-content mt-0">
                  <Col className=" w-90  flex-wrap  p-0">
                    <div
                      className="w-100 p-1 pt-0 pb-0"
                      style={{ position: "relative" }}
                    >
                      {" "}
                      <div className="data-col p-0 pt-1">
                        <div className="data-label w-25">
                          Payment Number
                          <span className="mandatory">*</span>
                        </div>
                        <div className="data-value w-75">
                          <Form.Item
                            name="paymentId"
                            label={undefined}
                            className="w-100 paddingLeft10  p-0 m-0"
                            rules={[
                              {
                                required: numberingMode === "manual",
                                message: "Please enter Payment Number",
                              },
                            ]}
                          >
                            <Input
                              placeholder={
                                numberingMode === "auto"
                                  ? "Auto-generated"
                                  : "Enter Payment Number"
                              }
                              className="w-100"
                              disabled={numberingMode === "auto"}
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <Tooltip title="Click here to enable or disable auto-generation of payment numbers.">
                        <SettingOutlined
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "18px",
                            color: "#1890ff",
                            zIndex: 1,
                          }}
                          onClick={() => {
                            setTempNumberingMode(numberingMode);
                            setShowNumberingModal(true);
                          }}
                        />
                      </Tooltip>
                    </div>

                    <div className="w-100 p-1 pt-0 pb-0">
                      <div className="data-row d-flex align-items-center py-1">
                        <div className="data-label w-25">
                          Approval Required ?
                          <span className="mandatory">*</span>
                        </div>
                        <div className="data-value w-75">
                          <Form.Item
                            name="approvals"
                            label={undefined}
                            className="w-100 paddingLeft10 p-0 m-0"
                            rules={[
                              {
                                required: true,
                                message: "Please select approvals",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Approvals"
                              value={approvalRequired}
                              onChange={(e) => {
                                form2.setFieldValue("approvals", e);
                                setApprovalRequired(() => e);
                              }}
                            >
                              <Option value="true">Yes</Option>
                              <Option value="false">No</Option>
                            </Select>

                            {approvalRequired == "true" && (
                              <Popover
                                content="Click here to set required approvals"
                                title="Approval Required"
                              >
                                <span className="m-1">
                                  <a
                                    href="#"
                                    className="success m-0 p-0"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setApprovals((pre) => {
                                        return {
                                          ...pre,
                                          open: true,
                                        };
                                      });
                                    }}
                                  >
                                    <EditOutlined /> Set Approvals &nbsp;
                                    {approvals?.data?.length == 0 ? (
                                      <span className="mandatory">
                                        Please set approvals
                                      </span>
                                    ) : (
                                      <></>
                                    )}
                                  </a>
                                </span>
                              </Popover>
                            )}
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="w-100 p-1 pt-0 pb-0">
                      <div className="data-row d-flex align-items-center py-1">
                        <div className="data-label w-25">
                          Payment Date
                          <span className="mandatory">*</span>
                        </div>
                        <div className="data-value w-75">
                          <Form.Item
                            name="paymentDate"
                            label={undefined}
                            className="w-100 paddingLeft10  p-0 m-0"
                            rules={[
                              {
                                required: true,
                                message: "Please select payment Date",
                              },
                            ]}
                          >
                            <DatePicker
                              className="w-100"
                              placeholder="Payment Date"
                              maxDate={dayjs()}
                              allowClear
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div className="w-100 p-1 pt-0 pb-0">
                      <div className="data-row d-flex align-items-center py-1">
                        <div className="data-label w-25">
                          Payment Mode
                          <span className="mandatory">*</span>
                        </div>
                        <div className="data-value w-75">
                          <Form.Item
                            name="paymentMode"
                            label={undefined}
                            className="w-100 paddingLeft10  p-0 m-0"
                            rules={[
                              {
                                required: true,
                                message: "Please select payment mode",
                              },
                            ]}
                          >
                            <Select
                              placeholder="Select Payment Mode"
                              className="w-100"
                              onChange={(e) => {
                                setPaymentMode(e);
                                // Reset fields below payment mode when payment mode changes
                                form2.setFieldsValue({
                                  transactionNumber: undefined,
                                  financialInstitutionName: undefined,
                                  bankAccountNumber: undefined,
                                  remarks: undefined,
                                });
                              }}
                            >
                              <Option value="neft">
                                National Electronic Fund Transfer (NEFT)
                              </Option>
                              <Option value="rtgs">
                                Real Time Gross Settlement (RTGS)
                              </Option>
                              <Option value="cheque">CHEQUE</Option>
                              <Option value="upi">UPI</Option>
                              <Option value="cash">CASH</Option>
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    {paymentMode && (
                      <>
                            {paymentMode !== "cash" && (
                              <>
                              <div className="w-100 p-1 pt-0 pb-0">
                                <div className="data-row d-flex align-items-center py-1">
                                  <div className="data-label w-25">
                                    Bank Name
                                    <span className="mandatory">*</span>
                                  </div>
                                  <div className="data-value w-75">
                                    <Form.Item
                                      name="financialInstitutionName"
                                      label={undefined}
                                      className="w-100 paddingLeft10  p-0 m-0"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Please enter Bank Name",
                                        },
                                        {
                                          pattern: /^[A-Za-z\s&.'-]+$/,
                                          message:
                                            "Bank name should contain only letters",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Enter Bank Name"
                                        className="w-100"
                                        onInput={(
                                          event: React.FormEvent<HTMLInputElement>,
                                        ) => {
                                          event.currentTarget.value =
                                            event.currentTarget.value.replace(
                                              /[^A-Za-z\s&.'-]/g,
                                              "",
                                            );
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                               <div className="w-100 p-1 pt-0 pb-0">
                              <div className="data-row d-flex align-items-center py-1">
                                <div className="data-label w-25">
                                  Bank Account Number
                                  <span className="mandatory">*</span>
                                </div>
                                <div className="data-value w-75">
                                  <Form.Item
                                    name="bankAccountNumber"
                                    label={undefined}
                                    className="w-100 paddingLeft10  p-0 m-0"
                                    rules={[
                                      {
                                        required: true,
                                        message:
                                          "Please enter Bank Account Number",
                                      },
                                    ]}
                                  >
                                    <Input
                                      placeholder="Enter Bank Account Number"
                                      className="w-100"
                                      onKeyPress={(event) => {
                                        if (!/^[0-9]$/.test(event.key)) {
                                          event.preventDefault();
                                        }
                                      }}
                                    />
                                  </Form.Item>
                                </div>
                              </div>
                            </div>
                            </>
                            )}

                           
                            {["neft", "rtgs", "imps"].includes(paymentMode) && (
                              <div className="w-100 p-1 pt-0 pb-0">
                                <div className="data-row d-flex align-items-center py-1">
                                  <div className="data-label w-25">
                                    UTR<span className="mandatory">*</span>
                                  </div>
                                  <div className="data-value w-75">
                                    <Form.Item
                                      name="transactionNumber"
                                      className="w-100 paddingLeft10 p-0 m-0"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Please enter UTR",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Enter UTR"
                                        className="w-100"
                                        onKeyPress={(event) => {
                                          if (
                                            !/^[a-zA-Z0-9/-]$/.test(event.key)
                                          ) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            )}

                            {["upi"].includes(paymentMode) && (
                              <div className="w-100 p-1 pt-0 pb-0">
                                <div className="data-row d-flex align-items-center py-1">
                                  <div className="data-label w-25">
                                    Transaction ID
                                    <span className="mandatory">*</span>
                                  </div>
                                  <div className="data-value w-75">
                                    <Form.Item
                                      name="transactionNumber"
                                      className="w-100 paddingLeft10 p-0 m-0"
                                      rules={[
                                        {
                                          required: true,
                                          message:
                                            "Please enter Transaction ID",
                                        },
                                      ]}
                                    >
                                      <Input
                                        placeholder="Enter Transaction ID"
                                        className="w-100"
                                        onKeyPress={(event) => {
                                          if (
                                            !/^[a-zA-Z0-9/-]$/.test(event.key)
                                          ) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            )}

                            {["cheque"].includes(paymentMode) && (
                              <div className="w-100 p-1 pt-0 pb-0">
                                <div className="data-row d-flex align-items-center py-1">
                                  <div className="data-label w-25">
                                    Cheque #<span className="mandatory">*</span>
                                  </div>
                                  <div className="data-value w-75">
                                    <Form.Item
                                      name="transactionNumber"
                                      className="w-100 paddingLeft10 p-0 m-0"
                                      rules={[
                                        {
                                          required: true,
                                          message: "Please enter Cheque Number",
                                        },
                                      ]}
                                    >
                                      <InputNumber
                                        placeholder="Enter Cheque Number"
                                        className="w-100"
                                        onKeyPress={(event) => {
                                          if (!/^[0-9]$/.test(event.key)) {
                                            event.preventDefault();
                                          }
                                        }}
                                      />
                                    </Form.Item>
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                    <div className="w-100 p-1 pt-0 pb-0">
                      <div className="data-col p-0 pt-1">
                        <div className="data-label w-25">
                          Remarks
                          <span className="mandatory">*</span>
                        </div>
                        <div className="data-value w-75">
                          <Form.Item
                            name="remarks"
                            label={undefined}
                            className="w-100 paddingLeft10  p-0 m-0"
                          >
                            <Input.TextArea
                              rows={3}
                              placeholder="Enter Remark"
                              onChange={(e) => {}}
                            />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </Col>
                </div>
              </div>
            </div>
          </Form>
          {approvals.open && (
            <PaymentsApprovalDrawer
              open={approvals.open}
              siteId={selectedSiteId}
              onClose={() => {
                setApprovals((pre) => {
                  return {
                    ...pre,
                    open: false,
                  };
                });
              }}
              onSubmit={(data: any, isStrictApprovalFromDrawer: boolean) => {
                setApprovals({
                  open: false,
                  data: data,
                });
                setIsStrictApproval(isStrictApprovalFromDrawer);
              }}
              initialStrictApproval={isStrictApproval}
              setApprovalSubmissionStatus={(status: boolean) => {}}
              approvalData={approvals.data} // Pass the current approval data
            />
          )}
        </Drawer>
      )}

      {/* Payment Number Configuration Modal */}
      <AntdModal
        title="Configure Payment Number Preference"
        open={showNumberingModal}
        onCancel={() => setShowNumberingModal(false)}
        zIndex={1200}
        footer={
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              gap: "10px",
            }}
          >
            <Button
              key="save"
              color="primary"
              onClick={() => {
                if (tempNumberingMode === "auto" && !currentSiteSequence) {
                  message.error(
                    "Auto-generation is not configured for this site.",
                  );
                  return;
                }

                setNumberingMode(tempNumberingMode);

                if (tempNumberingMode === "auto" && currentSiteSequence) {
                  const { prefix } = currentSiteSequence;
                  const paymentNumber = `${prefix}`;
                  form2.setFieldValue("paymentId", paymentNumber);
                } else if (tempNumberingMode === "manual") {
                  form2.setFieldValue("paymentId", "");
                }
                setShowNumberingModal(false);
              }}
            >
              Save
            </Button>

            <Button
              key="cancel"
              color="primary"
              onClick={() => setShowNumberingModal(false)}
            >
              Cancel
            </Button>
          </div>
        }
      >
        <div style={{ marginBottom: 20, lineHeight: "22px" }}>
          Your payment numbers are currently set to auto-generate to save time.
          <br />
          Are you sure you want to change this setting?
        </div>

        {!selectedSiteId && (
          <div style={{ color: "#8c8c8c", marginBottom: 16 }}>
            <InfoCircleOutlined /> Sequence configuration is not set for this
            site. Please configure the sequence.
          </div>
        )}

        {selectedSiteId && !currentSiteSequence && (
          <div style={{ color: "#faad14", marginBottom: 16 }}>
            <InfoCircleOutlined />{" "}
            {activeSequences.length === 0
              ? "No sequences configured for Payments. Please set up a sequence first."
              : "No sequence configured for the selected site. Please set a sequence for this site."}
          </div>
        )}

        <Radio.Group
          onChange={(e) => setTempNumberingMode(e.target.value)}
          value={tempNumberingMode}
        >
          <Space direction="vertical" style={{ width: "100%" }}>
            <Radio value="auto" disabled={!canAuto}>
              <span style={{ fontWeight: 500 }}>
                Continue auto-generating payment numbers
              </span>
            </Radio>

            <Radio value="manual">
              <span style={{ fontWeight: 500 }}>
                Enter payment numbers manually
              </span>
            </Radio>
          </Space>
        </Radio.Group>
      </AntdModal>
    </>
  );
};

export default InvoicePayables;
